import { render, staticRenderFns } from "./WarehouseNew.vue?vue&type=template&id=336f91b8&"
import script from "./WarehouseNew.vue?vue&type=script&lang=js&"
export * from "./WarehouseNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports